import React, { Component, } from 'react';
import Textarea from 'react-textarea-autosize';

import StyledControlledTextArea from './styles/StyledControlledTextArea';


class ControlledTextArea extends Component {
  render() {
    const { onChange, value, placeholder, inputState, name, } = this.props;
    return(
      <StyledControlledTextArea
        inputState={inputState}
      >
        <Textarea
          className="form-control controlled-textarea"
          value={value}
          onChange={(e) => onChange(e.target.value, name)}
          placeholder={placeholder}
          maxRows={10}
        />
      </StyledControlledTextArea>
    );
  }
}


export default ControlledTextArea;



// WEBPACK FOOTER //
// ./src/common/ControlledTextArea/ControlledTextArea.js